import { Button } from '@hakimo-ui/shared/ui-base';
import clsx from 'clsx';
import { useLayoutEffect, useRef, useState } from 'react';

interface Props {
  isRequested: boolean;
  isLoading: boolean;
  transcript?: string;
  onRequest: () => void;
}

export function InlineCallTranscript(props: Props) {
  const { isRequested, isLoading, transcript, onRequest } = props;
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isLong, setIsLong] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el || !transcript) {
      return;
    }
    const checkLength = () => {
      const lineHeight =
        parseFloat(window.getComputedStyle(el).lineHeight) || 0;
      const maxHeight = lineHeight * 3 + 1;
      setIsLong(el.scrollHeight > maxHeight);
    };
    checkLength();
    const observer = new ResizeObserver(checkLength);
    observer.observe(el);
    return () => observer.disconnect();
  }, [transcript]);

  if (!isRequested) {
    return (
      <div className="-ml-3 -mt-1">
        <Button
          variant="link"
          className="text-ondark-primary text-xs"
          onClick={onRequest}
        >
          View transcript
        </Button>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="text-onlight-text-2 dark:text-ondark-text-2 mt-2 text-xs">
        Loading transcript...
      </div>
    );
  }

  if (!transcript) {
    return (
      <div className="text-onlight-text-2 dark:text-ondark-text-2 mt-2 text-xs">
        Transcript not available.
      </div>
    );
  }

  return (
    <div className="mt-2 px-3">
      <p
        ref={textRef}
        className={clsx(
          'whitespace-pre-wrap break-words text-xs text-gray-800 dark:text-gray-400',
          isCollapsed && 'line-clamp-3'
        )}
      >
        {transcript}
      </p>
      {isLong && (
        <Button
          variant="link"
          className="text-ondark-primary -ml-4 -mt-2 text-xs"
          onClick={() => setIsCollapsed((v) => !v)}
        >
          {isCollapsed ? 'show more' : 'show less'}
        </Button>
      )}
    </div>
  );
}

export default InlineCallTranscript;
